import { reducer as about } from './modules/about';
import { reducer as app } from './modules/app';
import { reducer as alerts } from './modules/alerts';
import { reducer as forms } from './modules/forms';
import { reducer as layout } from './modules/layout';
import { reducer as profile } from './modules/profile';
import { reducer as teams } from './modules/teams';

export default {
  about,
  alerts,
  app,
  forms,
  layout,
  profile,
  teams,
};
